export const PageDataState = {
    Searchs: {
        training_details_enterprise_eb_03_id: {
            type: 'text',
            id: 'training_details_enterprise_eb_03_id',
            label: '',
            value: '',
            placeholder: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false
            },
            error: { status: null, msg: '' }
        },
        training_details_enterprise_eb_03_id: {
            type: 'select',
            id: 'training_details_enterprise_eb_03_id',
            label: 'รุ่น/ผู้ประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },   
        paid_trainee_count: {
            type: 'text',
            id: 'paid_trainee_count',
            label: 'บริษัทฯ ชำระค่าลงทะเบียนให้ผู้เข้ารับการอบรมรวม',
            value: '',
            placeholder: 'จำนวน',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 10000
            },
            error: { status: null, msg: '' }
        }, 
        amount: {
            type: 'text',
            id: 'amount',
            label: 'จำนวน',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 100000
            },
            error: { status: null, msg: '' }
        }, 
        fullname: {
            type: 'text',
            id: 'fullname',
            label: 'ผู้รายงาน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        }, 
        position: {
            type: 'text',
            id: 'position',
            label: 'ตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },  
        form_date: {
            type: 'text',
            id: 'form_date',
            label: 'วันที่',
            value: '',
            validator: {
                type: 'date',
                required: true
            },
            error: { status: null, msg: '' }
        },
        evidence: {
            type: 'file',
            id: 'evidence',
            label: 'เอกสารหลักฐาน',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "application/pdf,application/msword"
            },
            error: { status: null, msg: '' }
        },
        /**
        enterprise_id: {
            type: 'select',
            id: 'enterprise_id',
            label: 'ผู้ประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        start_date: {
            type: 'text',
            id: 'start_date',
            label: 'วันที่เริ่มต้น',
            value: '',
            validator: {
                type: 'date',
                required: true
            },
            error: { status: null, msg: '' }
        }, 
        end_date: {
            type: 'text',
            id: 'end_date',
            label: 'วันที่สิ้นสุด',
            value: '',
            validator: {
                type: 'date',
                required: true
            },
            error: { status: null, msg: '' }
        }, 
        */                        
    },
    InputGroup: {}
}                